import { render, staticRenderFns } from "./DocumentValueModal.vue?vue&type=template&id=1608e6a4&"
import script from "./DocumentValueModal.vue?vue&type=script&lang=js&"
export * from "./DocumentValueModal.vue?vue&type=script&lang=js&"
import style0 from "./DocumentValueModal.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports